module.exports = __webpack_public_path__ + "static/img/case_tab_08.97b4804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_08.png
// module id = Dgfo
// module chunks = 34